<template>
  <div class="page-layout">
    <m-scrollbar>
      <rules-article />
    </m-scrollbar>
  </div>
</template>

<script>
import MScrollbar from '@/components/MScrollbar'
import RulesArticle from '@/components/rules/article/Article'

export default {
  components: { MScrollbar, RulesArticle },
  mounted () {
    this.dispatchGetting()
  },
  watch: {
    '$route' (to, from) {
      this.dispatchGetting()
    },
    '$i18n.locale' (to, from) {
      this.dispatchGetting()
    }
  },
  methods: {
    dispatchGetting () {
      this.$store.dispatch('rules/GET_ARTICLE', this.$route.params.article)
    }
  }
}
</script>

<style scoped>
.page-layout { height: 100%; }
</style>



// WEBPACK FOOTER //
// src/components/rules/article/View.vue